<!--
================================================
Vue de la pointeuse
@deprecated @since 0.30.1

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <app-layout-comp>
        <div slot="AppContent" id="TimeclockView">

<!--            <welcome-tour-comp></welcome-tour-comp>-->

            <div class="columns is-desktop">
                <div class="column is-one-third-desktop">
                    <pointeuse-comp></pointeuse-comp>
                </div>

                <div class="column is-two-third-desktop">
                    <timerecords-activity-charts-comp></timerecords-activity-charts-comp>
                </div>
            </div>

            <hr style="height: 1px; background: #ddd">

            <my-recent-activity-comp></my-recent-activity-comp>
        </div>
    </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import AppLayoutComp from '@/components/AppLayoutComp.vue'
    import PointeuseComp from '@/components/PointeuseComp.vue'
    import MyRecentActivityComp from '@/components/MyRecentActivityComp.vue'
    import TimerecordsActivityChartsComp from "../components/TimerecordsActivityChartsComp";
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import WelcomeTourComp from "@/components/WelcomeTourComp.vue";

    export default {
        name: 'TimeclockView',
        components: {
            MyRecentActivityComp,
            AppLayoutComp,
            PointeuseComp,
            TimerecordsActivityChartsComp,
            WelcomeTourComp
        },
        mixins: [VueMetaMixin, ],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleTimeclockView"),this.$t("metaDescDefault"))
        },
        mounted: function () {
        },
        methods: {



        }
        //==========================================================
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">

</style>
